export const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(amount);
};

export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }).format(date);
};

export const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(date);
};

export const formatRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
};

export const getStatusColor = (status) => {
    const colors = {
        Created: "bg-yellow-100 text-yellow-800 border-yellow-200",
        Quoted: "bg-blue-100 text-blue-800 border-blue-200",
        Validated: "bg-purple-100 text-purple-800 border-purple-200",
        Accepted: "bg-green-100 text-green-800 border-green-200",
        Cancelled: "bg-red-100 text-red-800 border-red-200",
        Expired: "bg-gray-100 text-gray-800 border-gray-200",
        Draft: "bg-gray-100 text-gray-600 border-gray-200",
        ReceivedByAccountant: "bg-blue-100 text-blue-800 border-blue-200",
        VerifiedByOps: "bg-green-100 text-green-800 border-green-200",
        Completed: "bg-green-100 text-green-800 border-green-200",
    };
    return colors[status] || "bg-gray-100 text-gray-800 border-gray-200";
};
export const getOperationCompleteTotalRate = (data = []) => {
    let totalRequests = 0;
    let completedRequests = 0;

    data.forEach((item) => {
        totalRequests += item.total_requests || 0;
        completedRequests += item.completed_requests || 0;
    });

    if (totalRequests === 0 && completedRequests > 0) {
        return 100;
    } else if (totalRequests === 0 && completedRequests === 0) {
        return 0;
    }

    return Math.round((completedRequests / totalRequests) * 100);
};

export const getOperationCompletionRate = (data) => {
    let totalRequests = data.total_requests || 0;
    let completedRequests = data.completed_requests || 0;

    if (totalRequests === 0 && completedRequests > 0) {
        return 100;
    } else if (totalRequests === 0 && completedRequests === 0) {
        return 0;
    }

    return Math.round((completedRequests / totalRequests) * 100);
};


export const toTitleCase = (str = "") => {
    return str.toLowerCase().split(' ')
        .map(function (word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
        })
        .join(' ');
}